import { initializeApp } from "firebase/app";
import { getFirestore, onSnapshot, Query } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { Store } from "vuex";

export const app = initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
});

export const auth = getAuth(app);
export const firestore = getFirestore(app);

function insertItem(array: any[], index: number, item: any) {
  return [...array.slice(0, index), item, ...array.slice(index)];
}

function removeItem(array: any[], index: number) {
  return [...array.slice(0, index), ...array.slice(index + 1)];
}

function replaceItem(array: any[], index: number, item: any) {
  return [...array.slice(0, index), item, ...array.slice(index + 1)];
}

export function bindAsArray(store: Store<any>, key: string, query: Query) {
  let initialized = false;
  store.state[key] = [];

  return new Promise<() => void>(resolve => {
    const unsubscribe = onSnapshot(query, snapshot => {
      if (!initialized) {
        initialized = true;
        store.state[key] = snapshot.docs.map(doc => doc.data());
        resolve(unsubscribe);
        return;
      }

      snapshot.docChanges().forEach(({ type, doc, oldIndex, newIndex }) => {
        if (type === "modified") {
          if (oldIndex === newIndex) {
            store.state[key] = replaceItem(store.state[key], oldIndex, doc.data());
          } else {
            store.state[key] = removeItem(store.state[key], oldIndex);
            store.state[key] = insertItem(store.state[key], newIndex, doc.data());
          }
        } else if (type === "added") {
          store.state[key] = insertItem(store.state[key], newIndex, doc.data());
        } else if (type === "removed") {
          store.state[key] = removeItem(store.state[key], oldIndex);
        }
      });
    });
  });
}

export function bindAsDictionary(store: Store<any>, key: string, query: Query) {
  let initialized = false;
  store.state[key] = {};

  return new Promise<() => void>(resolve => {
    const unsubscribe = onSnapshot(query, snapshot => {
      if (!initialized) {
        initialized = true;
        snapshot.docs.forEach(doc => (store.state[key][doc.id] = doc.data()));
        resolve(unsubscribe);
        return;
      }

      snapshot.docChanges().forEach(({ type, doc }) => {
        if (type === "added" || type === "modified") {
          store.state[key] = {
            ...store.state[key],
            [doc.id]: doc.data()
          };
        } else if (type === "removed") {
          store.state[key] = {
            ...store.state[key],
            [doc.id]: undefined
          };
        }
      });
    });
  });
}
